import { createReducer, on } from '@ngrx/store';
import { HaloConfig } from '@octiga/psa/halo.interface';
import { deleteMspHaloIntegrationSuccess } from '../credentials/actions';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspHaloConfig';

export interface State extends Status {
    data: HaloConfig | null;
}

export const initialState: State = {
    data: null,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.loadMspHaloConfig, (state) => ({ ...state, loading: true })),
    on(actions.loadMspHaloConfigSuccess, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(actions.loadMspHaloConfigFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(actions.updateMspHaloConfigSuccess, (state) => ({ ...state })),
    on(deleteMspHaloIntegrationSuccess, () => initialState),
);

export const selectData = (state: State) => state.data;
